module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-block",
    attrs: {
      "data-lang": _vm.lang
    }
  }, [_c('div', {
    staticClass: "code-block-wrapper",
    style: ({
      'max-height': _vm.height
    })
  }, [_c('pre', [_c('code', {
    ref: "block",
    class: _vm.lang
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span', {
    staticClass: "copied",
    class: {
      'active': _vm.showMessage
    }
  }, [_vm._v("Copied!")])]), _vm._v(" "), _c('md-button', {
    ref: "copy",
    staticClass: "md-icon-button md-dense"
  }, [_c('md-icon', [_vm._v("content_copy")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1da962d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeBlock.vue
// module id = 528
// module chunks = 83